import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <h5>National Parks Board</h5>

        <ul className="social-icon social-menu">
          <li>
            <a href="https://www.nparks.gov.sg/contact-us">Contact Us</a>
          </li>
          <li>
            <a href="/eservices/userguides">User Guides</a>
          </li>
          <li>
            <a href="https://www.nparks.gov.sg/contact-us#feedback">
              Feedback
            </a>
          </li>
           {/*<li>
            <a href="https://www.nparks.gov.sg/faqs">FAQs</a>
          </li>*/}
        </ul>
        <div className="copyright">
          <div className="row">
            <div className="col-12 col-md-6">
              <ul>
                <li>
                  <a href="https://www.tech.gov.sg/report_vulnerability">
                    Report Vulnerability
                  </a>
                </li>
                <li>
                  <a href="https://www.nparks.gov.sg/privacy-statement">
                    Privacy Statement
                  </a>
                </li>
                <li>
                  <a href="https://www.nparks.gov.sg/terms-of-use">
                    Terms of Use
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-6">
              <p className="m-0">
                © {new Date().getFullYear()} National Parks Board. Last updated{" "}
                {new Date().toLocaleString("en-US", {
                  month: "short",
                  year: "numeric",
                })}
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
